/* RESPONSIBLE TEAM: team-standalone */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';
import type ZendeskTicketsDataController from 'embercom/controllers/apps/app/standalone/deploy/zendesk/tickets/data';

export default class FinStandaloneDeployZendeskTicketsDataRoute extends Route {
  @service declare router: RouterService;

  queryParams = {
    section: {
      refreshModel: false,
    },
  };

  setupController(
    controller: ZendeskTicketsDataController,
    model: unknown,
    transition: Transition,
  ) {
    super.setupController(controller, model, transition);
    controller.set('section', null);
  }
}
